import {
  ILoadingCellRendererComp,
  ILoadingCellRendererParams,
} from "ag-grid-enterprise";

export interface LoadingCellRendererParams extends ILoadingCellRendererParams {
  loadingIndicatorTemplate: string;
}

export class LoadingCellRenderer implements ILoadingCellRendererComp {
  private eGui!: HTMLElement;

  init(params: LoadingCellRendererParams): void {
    this.eGui = document.createElement("div");

    const isOverlayActive = this.isLoadingOverlayActive(params);
    const isGroupRow = this.isGroupRow(params);

    if (isOverlayActive || !isGroupRow) {
      this.eGui.innerHTML = "";
    } else {
      this.eGui.innerHTML = params.loadingIndicatorTemplate;
    }
  }

  getGui() {
    return this.eGui;
  }

  refresh(params: LoadingCellRendererParams): boolean {
    const isOverlayActive = this.isLoadingOverlayActive(params);

    if (isOverlayActive) {
      this.eGui.innerHTML = "";
    } else {
      this.eGui.innerHTML = params.loadingIndicatorTemplate;
    }

    return false;
  }

  isLoadingOverlayActive(params: LoadingCellRendererParams): boolean {
    return params.api?.getGridOption?.("loading") === true;
  }

  isGroupRow(params: LoadingCellRendererParams): boolean {
    return params.node?.parent?.group && params.node?.parent?.expanded;
  }
}
